export interface FieldTypeInterface {
  birthDate: 'birthDate';
  email: 'email';
  guardian: 'guardian';
}
export const FieldType: FieldTypeInterface = {
  birthDate: 'birthDate',
  email: 'email',
  guardian: 'guardian',
} as const;

export interface FondFieldTypeInterface {
  fondName: 'fondName';
  isin: 'isin';
  chartView: 'chartView';
  orderPreviousItem: 'orderPreviousItem';
}

export const FondFieldType: FondFieldTypeInterface = {
  fondName: 'fondName',
  isin: 'isin',
  chartView: 'chartView',
  orderPreviousItem: 'orderPreviousItem',
} as const;
